export default __webpack_public_path__ + "72cbec2c0c04573d4e45758b229ab018.png";